import {createSlice} from '@reduxjs/toolkit';
import {LOCAL_STORAGE_AUTH_TOKEN} from '@app/constants/Common';

const initialState = {
    isLoggedIn: !!localStorage.getItem('token'),
    token: localStorage.getItem('token'),
    currentUser: {
        email: 'mail@example.com',
        picture: null
    }
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginUser: (state, {token}) => {
            localStorage.setItem(LOCAL_STORAGE_AUTH_TOKEN, token);
        },
        logoutUser: (state) => {
            localStorage.removeItem(LOCAL_STORAGE_AUTH_TOKEN);
        },
        loadUser: (state, {payload}) => {
            state.currentUser = payload;
        }
    }
});

export const {loginUser, logoutUser, loadUser} = authSlice.actions;

export default authSlice.reducer;
